'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var index =  react.useLayoutEffect ;

exports.default = index;
